import { createAction } from '@af-common/Common/_actions/Action';

export enum ModuleActionType {
	ModuleOnValueUpdate			= 'MODULE_ON_VALUE_UPDATE',
	ModuleOnMultipleValueUpdate	= 'MODULE_ON_MULTIPLE_VALUE_UPDATE',
	ModuleOnDuplicate			= 'MODULE_ON_DUPLICATE',
	ModuleOnFitToTile			= 'MODULE_ON_FIT_TO_TILE',
}

export const ModuleOnValueUpdate = (moduleId: string, key: string, value: any) => createAction(ModuleActionType.ModuleOnValueUpdate, {
	moduleId	: moduleId,
	key			: key,
	value		: value
});

export const ModuleOnMultipleValueUpdate = (moduleId: string, updates:{[key:string] : any}) => createAction(ModuleActionType.ModuleOnMultipleValueUpdate, {
	moduleId	: moduleId,
	updates		: updates,
});

export const ModuleOnDuplicate = (moduleId: string) => createAction(ModuleActionType.ModuleOnDuplicate, {
	moduleId	: moduleId,
})

export const ModuleOnFitToTile = (moduleId: string) => createAction(ModuleActionType.ModuleOnFitToTile, {
	moduleId	: moduleId,
})

export type ModuleAction = 
	ReturnType<typeof ModuleOnValueUpdate>			|
	ReturnType<typeof ModuleOnMultipleValueUpdate>	|
	ReturnType<typeof ModuleOnDuplicate>			|
	ReturnType<typeof ModuleOnFitToTile>